/*
 * File: /src/router/routes/leadStatuses.js
 * Created Date: Saturday December 7th 2024
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 7th December 2024 11:29:50 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2024 AdBase, Inc.
 */

const ListTypes = () =>
  import(
    /* webpackChunkName: "LeadStatuses" */ 'src/components/Dashboard/Views/LeadStatuses/LeadStatusList.vue'
  );

const EditType = () =>
  import(
    /* webpackChunkName: "LeadStatuses" */ 'src/components/Dashboard/Views/LeadStatuses/LeadStatusEdit.vue'
  );

export const leadStatusRoutes = [
  {
    path: 'lead-statuses/',
    name: 'Lead Status',
    component: ListTypes,
  },
  {
    path: 'lead-statuses/add',
    name: 'Add New Lead Status',
    component: EditType,
  },
  {
    path: 'lead-statuses/edit/:leadStatusId',
    name: 'Edit Lead Status',
    component: EditType,
    props: (route) => ({
      leadStatusId: parseInt(route.params.leadStatusId),
    }),
  },
];
